import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ab325ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-menu-5" }, null, -1))
const _hoisted_3 = { class: "categories" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-home" }, null, -1))
const _hoisted_5 = ["onClick"]

import gospel, { State } from '@/store/gospel/home';
import i18, { State as I18State } from '@/store/i18';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const gospelState = computed<State>(() => store.state[gospel.name])
const categories = computed(() => gospelState.value.menu)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].gospel)

const categoryId = computed(() => parseInt(route.query.id as string))

function goHome() {
    router.push({ name: 'gospel' })
}
function goCateogry(id: number) {
    router.push({
        name: 'gospel/categories',
        params: {
            id
        }
    })
}

const icons = ['i-zuixinfabu', 'i-new', 'i-a-5shengmingjianzheng', 'i-menu-4']


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).gospel), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: _normalizeClass(["navigator", { on: _unref(route).name == 'gospel' }]),
        onClick: goHome
      }, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_unref(lang).home), 1)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (item, i) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["navigator", { on: _unref(route).name == 'gospel/categories' && _unref(categoryId) == item.id }]),
          onClick: ($event: any) => (goCateogry(item.id))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["icon", icons[i]])
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(item.name), 1)
        ], 10, _hoisted_5))
      }), 256))
    ])
  ]))
}
}

})